import { tokenStorage } from '@/entities/session/token-storage';

const SIM_TOKEN_KEY = 'fc.player.sim.token';
const SIM_BASE_KEY = 'fc.player.sim.base';
const SIM_SITE_KEY = 'fc.player.sim.site';
const SIM_PENDING_KEY = 'fc.player.sim.pendingBase';

let simToken = '';
let simBaseUrl = '';
let simSiteId = '';
let simBindGeneration = 0;

const SIM_PATHS = [
  '/v1/app/wallet/balance',
  '/v1/app/wallet/currency',
  '/v1/app/payment/orders',
  '/v1/app/game/launch/',
];

export const getSimulationToken = () => simToken;
export const getSimulationApiBaseUrl = () => simBaseUrl;
export const getSimulationSiteId = () => simSiteId;

export const setSimulationSession = (token: string, baseUrl: string, siteId = '') => {
  simToken = token;
  simBaseUrl = baseUrl.replace(/\/$/, '');
  simSiteId = siteId;
  try {
    if (simToken) localStorage.setItem(SIM_TOKEN_KEY, simToken);
    else localStorage.removeItem(SIM_TOKEN_KEY);
    if (simBaseUrl) localStorage.setItem(SIM_BASE_KEY, simBaseUrl);
    else localStorage.removeItem(SIM_BASE_KEY);
    if (simSiteId) localStorage.setItem(SIM_SITE_KEY, simSiteId);
    else localStorage.removeItem(SIM_SITE_KEY);
    if (simToken) localStorage.removeItem(SIM_PENDING_KEY);
  } catch {
    // ignore
  }
};

export const markSimulationPending = (apiBaseUrl: string) => {
  const base = apiBaseUrl.replace(/\/$/, '');
  try {
    if (base) localStorage.setItem(SIM_PENDING_KEY, base);
    else localStorage.removeItem(SIM_PENDING_KEY);
  } catch {
    // ignore
  }
};

export const readSimulationPendingBase = () => {
  try {
    return localStorage.getItem(SIM_PENDING_KEY) ?? '';
  } catch {
    return '';
  }
};

export const beginSimulationBind = () => {
  simBindGeneration += 1;
  return simBindGeneration;
};

export const isCurrentSimulationBind = (generation: number) => generation === simBindGeneration;

export const clearSimulationSession = () => {
  simBindGeneration += 1;
  setSimulationSession('', '');
  try {
    localStorage.removeItem(SIM_PENDING_KEY);
  } catch {
    // ignore
  }
};

export const restoreSimulationSession = () => {
  if (!tokenStorage.read()) {
    clearSimulationSession();
    return;
  }
  try {
    simToken = localStorage.getItem(SIM_TOKEN_KEY) ?? '';
    simBaseUrl = localStorage.getItem(SIM_BASE_KEY) ?? '';
    simSiteId = localStorage.getItem(SIM_SITE_KEY) ?? '';
  } catch {
    simToken = '';
    simBaseUrl = '';
    simSiteId = '';
  }
};

export const hasSimulationMarker = () => {
  if (simToken || readSimulationPendingBase()) return true;
  try {
    return Boolean(localStorage.getItem(SIM_TOKEN_KEY) || localStorage.getItem(SIM_PENDING_KEY));
  } catch {
    return false;
  }
};

export const shouldUseSimulationApi = (path: string) => {
  if (!simToken || !simBaseUrl || !tokenStorage.read()) return false;
  return SIM_PATHS.some((prefix) => path === prefix || path.startsWith(prefix));
};
